<template>
  <v-container>
    <loader v-if="loading"></loader>

    <collapsible-section
      v-for="group in groups"
      v-bind:key="group"
    >
      <template slot="title">
        <span
          style="font-size: 1.4em;font-weight: bold; background-color: #2E76BF; color: white; padding: 2px 10px;border-radius: 5px; margin-bottom: 10px; display: inline-block"
        >{{
            group.name
          }}</span>
      </template>
      <div style="border: 1px solid #E1E1E1; padding: 10px; margin-bottom: 20px;">
        <data-table
          ref="table"
          :fetch-from="fetchForm"
          :fields="fields"
          :fetch-from-options="{group: group.gid}"
          @loaded="onTableLoaded"
        >
          <template
            slot="operationalDate"
            slot-scope="slotData"
          >
            {{ slotData.rowData.OperationalDate|formatDate|noDataAvailable }}
          </template>
          <template
            slot="actions"
            slot-scope="slotData"
          >
            <v-btn
              x-small
              color="primary"
              @click="showDetails(slotData.rowData)"
            >Details
            </v-btn>
          </template>
        </data-table>
      </div>
    </collapsible-section>
    <modal-form
      :title="title"
      :show.sync="dialog"
      :readonly="true"
      v-if="cellDetails"
    >
      <v-row>
        <v-col cols="3">
          <display-field label="CellName">{{ cellDetails.Cellname }}</display-field>
        </v-col>
        <v-col cols="3">
          <display-field
            label="Cell ID"
            :site="site"
            :editable="false"
            edit-field="cell.CellId"
            :edit-value="cellDetails.CellId"
            :aid="cellDetails.Cellname"
            @updated="(nv)=>cellDetails.CellId=nv"
          >{{ cellDetails.CellId|noDataAvailable }}
          </display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="RBSName">{{ cellDetails.RBSName }}</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Band">{{ cellDetails.Band }}</display-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <display-field label="Flag Status">{{ cellDetails.FlagStatus }}</display-field>
        </v-col>
        <v-col cols="3">
          <display-field
            label="LAC"
            :site="site"
            :editable="true"
            edit-field="cell.LAC"
            :edit-value="cellDetails.LAC"
            :aid="cellDetails.Cellname"
            @updated="(nv)=>cellDetails.LAC=nv"
          >{{ cellDetails.LAC|noDataAvailable }}
          </display-field>
        </v-col>
        <v-col cols="3">
          <display-field
            label="Live Date Planned"
            :site="site"
            :editable="true"
            edit-field="cell.LiveDatePlanned"
            edit-type="date"
            :edit-value="cellDetails.LiveDatePlanned"
            :aid="cellDetails.Cellname"
            @updated="(nv)=>cellDetails.LiveDatePlanned=nv"
          >{{ cellDetails.LiveDatePlanned|formatDate|noDataAvailable }}
          </display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Operational Date">{{
              cellDetails.OperationalDate|formatDate|noDataAvailable
            }}
          </display-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <display-field
            label="Termination Date"
            :site="site"
            :editable="true"
            edit-field="cell.TerminationDate"
            edit-type="date"
            :edit-value="cellDetails.TerminationDate"
            :aid="cellDetails.Cellname"
            @updated="(nv)=>cellDetails.TerminationDate=nv"
          >{{ cellDetails.TerminationDate|formatDate|noDataAvailable }}
          </display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Acceptance date">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="MIMO">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field
            label="BCCH"
            :site="site"
            :editable="true"
            edit-field="cell.BCCH"
            :edit-value="cellDetails.BCCH"
            :aid="cellDetails.Cellname"
            @updated="(nv)=>cellDetails.BCCH=nv"
          >{{ cellDetails.BCCH|noDataAvailable }}
          </display-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <display-field label="BSIC">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="BTS-Power">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Carriers">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Cell Type">Data not available</display-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <display-field label="Coverage type">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="CPICH Power">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Modem Phone No">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="N° of Carriers">Data not available</display-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <display-field
            label="PCI"
            :site="site"
            :editable="true"
            edit-field="cell.pci"
            :edit-value="cellDetails.pci"
            :aid="cellDetails.Cellname"
            @updated="(nv)=>cellDetails.pci=nv"
          >{{ cellDetails.pci|noDataAvailable }}
          </display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Propagation Model">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Ref Signal Pwr">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="SAC">{{ cellDetails.SAC|noDataAvailable }}</display-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <display-field
            label="Scrambling Code"
            :site="site"
            :editable="true"
            edit-field="cell.primaryScramblingCode"
            :edit-value="cellDetails.primaryScramblingCode"
            :aid="cellDetails.Cellname"
            @updated="(nv)=>cellDetails.primaryScramblingCode=nv"
          >{{ cellDetails.primaryScramblingCode|noDataAvailable }}
          </display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="SDCCH">{{ cellDetails.SDCCH|noDataAvailable }}</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="TAC">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="TMA">Data not available</display-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="3"
        >
          <display-field
            label="PredModel"
            :site="site"
            :editable="true"
            edit-field="cell.PredModel"
            :edit-value="cellDetails.predmodel"
            :aid="cellDetails.Cellname+'|,|'+cellDetails.SectorAntennaBandName"
            edit-type="codelist"
            codelist="pred_model"
            @updated="(nv)=>cellDetails.predmodel=nv"
          >{{ cellDetails.predmodel|noDataAvailablel }}</display-field>
        </v-col>
        <v-col
          cols="3"
          v-if="cellDetails.enodebid"
        >
          <display-field
            label="EnodeBId"
            :site="site"
            :editable="true"
            edit-field="cell.enodebid"
            :edit-value="cellDetails.enodebid"
            :aid="cellDetails.Cellname"
            @updated="(nv)=>cellDetails.enodebid=nv"
          >{{ cellDetails.enodebid }}</display-field>
        </v-col>
      </v-row>
    </modal-form>
  </v-container>
</template>

<script>
  import DisplayField from '@/components/DisplayField'
  import ModalForm from '@/components/ModalForm'
  import DataTable from '@/components/DataTable'
  import SiteNwpService from '@/services/site-nwp'
  import Loader from '@/components/Loader'
  import CollapsibleSection from '../../../../components/CollapsibleSection'

  export default {
    name: 'CellInfo',
    components: {
      CollapsibleSection,
      Loader,
      DataTable,
      ModalForm,
      DisplayField,
    },
    props: {
      site: {
        default: undefined,
      },
      sector: {
        default: undefined,
      },
    },
    data: function () {
      return {
        dialog: false,
        loading: false,
        cellDetails: undefined,
        wasAutoLoaded: false,
        fields: [
          {
            name: 'cellname',
            title: 'Cell name',
          },
          {
            name: '__slot:operationalDate',
            title: 'Operational Date',
          },
          {
            name: 'band',
            title: 'Band',
          },
          {
            name: '__slot:actions',
            title: 'Actions',
          },
        ],
      }
    },
    computed: {
      title () {
        if (this.cellDetails) {
          return 'Cell ' + this.cellDetails.Cellname
        }
        return 'Cell'
      },
      groups () {
        return [{
          gid: 'gsm_2g',
          name: 'GSM (2G)',
        }, {
          gid: 'lte',
          name: 'LTE (4G)',
        }, {
          gid: 'new_radio',
          name: 'NEW RADIO (5G)',
        }, {
          gid: 'umts',
          name: 'UMTS (3G)',
        },
        ]
      },
    },
    methods: {
      fetchForm (urls, options) {
        const group = options.group
        const acs = new SiteNwpService()
        return acs.cells(this.site.id, this.sector.sector_id, group)
      },
      showDetails (item) {
        this.loading = true
        const acs = new SiteNwpService()
        acs.cellDetails(this.site.id, item.sector_id, item.cellname).then((response) => {
          this.cellDetails = response.data.data
          this.dialog = true
        }).finally(() => {
          this.loading = false
        })
      },
      onTableLoaded () {
        const selectedCell = this.$route.params.cellId
        if (selectedCell != null && !this.wasAutoLoaded) {
          const data = this.$refs.table.getData()
          for (const item of data) {
            if (item.cellname + '' === selectedCell) {
              setTimeout(() => {
                this.wasAutoLoaded = true
                this.showDetails(item)
              }, 200)
              break
            }
          }
        }
      },
    },
  }
</script>

<style scoped>

</style>
